import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'

const TanksPageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={() => navigate({ pathname: routes.tanksImport.path, search: `is_insert=true` })}>
        {t('components.pages.tanks.list.buttonAction.importAdd')}
      </Menu.Item>
    </Menu>
  )

  return (
    <PageHeader
      ghost={false}
      title={t('components.pages.tanks.list.pageHeader.title')}
      extra={[
        <>
          <Dropdown.Button
            key="action"
            type="primary"
            icon={<DownOutlined />}
            overlay={menu}
            onClick={() => navigate(routes.createTank.path)}
          >
            {t('components.pages.tanks.list.pageHeader.new')}
          </Dropdown.Button>
        </>,
      ]}
    />
  )
}

TanksPageHeader.displayName = 'TanksPageHeader'
export default TanksPageHeader
